import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownWithCodeDTO } from "../../../types/common/DropdownWithCodeDTO";

export interface IInvalidationTypeState {
  invalidationTypeDropdown: DropdownWithCodeDTO[];
}

export const initialState: IInvalidationTypeState = {
  invalidationTypeDropdown: []
};

export const invalidationTypeSlice = createSlice({
  name: 'invalidationType',
  initialState,
  reducers: {
    loadingInvalidationTypeDropdown: (state, action: PayloadAction<DropdownWithCodeDTO[]>) => {
      state.invalidationTypeDropdown = action.payload;
    },
  }
});

export const { loadingInvalidationTypeDropdown } = invalidationTypeSlice.actions;
export default invalidationTypeSlice.reducer;
